import { useRouter } from "next/router"

import { liveChatLicense } from "@config/livechat"
import useAuth from "@hooks/useAuth"
import useProfile from "@hooks/useProfile"
import useUserPreferences from "@hooks/useUserPreferences"
import { EventHandlerPayload, LiveChatWidget } from "@livechat/widget-react"

const Livechat: React.FC = () => {
    const { data, update } = useUserPreferences()
    const { transactionId } = data
    const { auth } = useAuth()
    const router = useRouter()
    const isOpen = data.livechat?.open
    const locale = router.locale as string

    const { profile } = useProfile()
    const customerName = profile?.fullName
    const customerEmail = profile?.email
    const userId = profile?.userId
    const { isLoggedIn } = auth

    const handleVisibilityChanged = (event: EventHandlerPayload<"onVisibilityChanged">) => {
        update({
            livechat: {
                open: event.visibility === "maximized"
            }
        })
    }

    const sessionVariables = isLoggedIn
        ? {
              name: customerName,
              email: customerEmail,
              userId: String(userId),
              activeLanguage: locale,
              ...(transactionId ? { transactionId } : {})
          }
        : undefined

    return (
        <LiveChatWidget
            license={liveChatLicense}
            visibility={isOpen ? "maximized" : "minimized"}
            onVisibilityChanged={handleVisibilityChanged}
            customerName={customerName}
            customerEmail={customerEmail}
            sessionVariables={sessionVariables}
        />
    )
}

export default Livechat
